import _ from "lodash";
import React from "react";

// Components
import { AssessmentCoverUpload } from "UnitPlans/components/IBcomponents";
import MoreItemWithToolTip from "UIComponents/MoreItemWithToolTip";

// DS
import { Avatar } from "@toddle-edu/ds-web";

// third party
import classNames from "classnames";

// Scss
import classes from "./CommunityBasicDetails.scss";

const styles = {
  tooltipContainerStyle: {
    maxHeight: "250px",
    overflowY: "auto",
  },
};

const LibraryGradesAndSubjects = props => {
  const { libraryDetails } = props;

  return (
    <div className={classes.libraryInfoContainer}>
      {_.map(libraryDetails, ({ label, items }) => (
        <div className={classes.libraryInfo} key={label}>
          <div className={classNames("text-label-2", classes.libraryInfoLabel)}>
            {label}
          </div>
          <div className={classNames("text-body-1", classes.libraryInfoValue)}>
            <MoreItemWithToolTip
              items={items}
              tooltipPlacement={"right"}
              length={2}
              moreAll={false}
              trigger={"hover"}
              tooltipContainerStyle={styles.tooltipContainerStyle}
              closeOnScroll={true}
              joinSymbol={", "}
            />
          </div>
        </div>
      ))}
    </div>
  );
};

const CommunityBasicDetails = props => {
  const { t, resourceDetails, isCommunity } = props;

  const {
    title: { value: title } = {},
    image: { value: image } = {},
    createdBy,
    libraryGrades,
    librarySubjects,
  } = resourceDetails || {};

  const libraryDetails = [
    {
      label: t("common:grade_plural"),
      items: _.map(libraryGrades, "label"),
    },
    {
      label: t("common:subject_plural"),
      items: _.map(librarySubjects, "label"),
    },
  ].filter(({ items }) => !_.isEmpty(items));

  const showLibraryDetails = !isCommunity && !_.isEmpty(libraryDetails);
  const showCreator = isCommunity;

  const {
    id: creatorId,
    firstName,
    lastName,
    profileImage,
    schoolTenures = [],
  } = createdBy;

  const creatorFullName = `${firstName} ${lastName}`;
  const schoolName = _.get(schoolTenures, "0.school.name", "");

  const titleClass = classNames("heading-2", classes.title);
  const creatorNameClass = classNames("text-label-3", classes.creatorName);
  const creatorSchoolClass = classNames("text-body-3", classes.creatorSchool);

  return (
    <div className={classes.container}>
      <AssessmentCoverUpload t={t} value={image} mode={"view"} />

      <div className={classes.infoContainer}>
        {showCreator ? (
          <div className={classes.userInfo}>
            <div className={classes.userInfoLeftContainer}>
              <Avatar
                shape={"circle"}
                shade={"light"}
                size={"medium"}
                name={creatorFullName}
                src={profileImage}
              />
            </div>
            <div className={classes.userInfoRightContainer}>
              <div className={creatorNameClass}>{creatorFullName}</div>
              <div className={creatorSchoolClass}>{schoolName}</div>
            </div>
          </div>
        ) : null}

        <div className={titleClass}>{title}</div>

        {showLibraryDetails ? (
          <LibraryGradesAndSubjects libraryDetails={libraryDetails} />
        ) : null}
      </div>
    </div>
  );
};

export default CommunityBasicDetails;
